import React from 'react'
import { Box } from '@chakra-ui/react'
import VoucherTable from './components/VoucherTable'

export default function VouchersView() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <VoucherTable />
    </Box>
  )
}
